<template>
  <div class="fan-user-box">
    <div class="fan-user" v-if="userInfo">
      <div class="first">
        <div class="label-box rank-none" v-if="userInfo.rank == 0">
          <span class="label-shadow">未上榜</span>
          <span class="label-text">未上榜</span>
        </div>
        <div class="label-box" v-else>
          <span class="label-shadow">{{ userInfo.rank }}</span>
          <span class="label-text">{{ userInfo.rank }}</span>
        </div>
      </div>
      <div class="nanu">
        <div
          class="avatar"
          :style="{
            'background-image': `url(${useImgUrl})`
          }"
        ></div>
        <div class="name">
          <div class="label-box">
            <span class="label-shadow">{{ userInfo.nickName }}</span>
            <span class="label-text">{{ userInfo.nickName }}</span>
          </div>
        </div>
      </div>
      <div class="hot">
        <div class="label-box">
          <span class="label-shadow">{{ countShow(userInfo.popularity) }}</span>
          <span class="label-text">{{ countShow(userInfo.popularity) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object,
      default: () => {}
    },
    useImgUrl: {
      type: String
    },
  },
  methods: {
    countShow(hot){
      if(hot){
        if(hot<10000){
          return hot
        }else if(10000 <= hot && hot < 99999999){
          return (((hot / 10000)* 100) /100).toFixed(2) + '万'
        }else {
          return  9999 +'万+'
        }
      }else{
        return  0
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.fan-user-box{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: get_vh(90px);
  border-radius:0 0 get_vh(10px) get_vh(10px);
  background-image: $bg_bottom;
  background-position: center 30%;
  background-size: cover;
  background-repeat: no-repeat;
  .fan-user {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: get_vh(65px);
    margin-top: get_vh(27px);
    font-size: get_vh(20px);
    .label-box {
      .label-shadow {
        color: rgba(0, 0, 0, 0.4);
      }
      .label-text {
        color: #FFFFFF;
      }
    }
  
    .first {
      box-sizing: border-box;
      width: get_vh(63px);
      font-size: get_vh(40px);
      font-weight: bold;
      font-family: NumFont;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: get_vh(55px);
      .rank-none {
        font-size: get_vh(26px);
      }
    }

    .nanu {
      box-sizing: border-box;
      width: 25%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-left: get_vh(40px);
      .avatar {
        width: get_vh(48px);
        height: get_vh(44.17px);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: get_vh(4px);
        border: get_vh(2px) solid #DDDDDD;
        margin-right: get_vh(14.51px);
      }
      .name {
        text-align: left;
      }
    }

    .hot {
      box-sizing: border-box;
      width: get_vh(86px);
      text-align: center;
      margin-right: get_vh(63px);
    }
  }
}

@media screen and (max-aspect-ratio: 5 / 3) {
  .fan-user-box {
    border-radius:0 0 get_vw(10px) get_vw(10px);
    .fan-user {
      font-size: get_vw(20px);
    
      .first {
        width: get_vw(63px);
        font-size: get_vw(40px);
        margin-left: get_vw(55px);
      }

      .nanu {
        margin-left: get_vw(40px);
        .avatar {
          width: get_vw(48px);
          height: get_vw(44.17px);
          border-radius: get_vw(4px);
          margin-right: get_vw(14.51px);
        }
      }

      .hot {
        width: get_vw(86px);
        margin-right: get_vw(63px);
      }
    }
  }
}

</style>